module.exports = __webpack_public_path__ + "img/badge_fair_gold.2f141522.png";